import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=658ace07&scoped=true&"
import script from "./NavLink.vue?vue&type=script&lang=js&"
export * from "./NavLink.vue?vue&type=script&lang=js&"
import style0 from "./NavLink.vue?vue&type=style&index=0&id=658ace07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ace07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('658ace07')) {
      api.createRecord('658ace07', component.options)
    } else {
      api.reload('658ace07', component.options)
    }
    module.hot.accept("./NavLink.vue?vue&type=template&id=658ace07&scoped=true&", function () {
      api.rerender('658ace07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nav/NavLink.vue"
export default component.exports